import { defineStore } from 'pinia';
import { householdApi } from '@/services/api/endpoints';
import { NetworkError } from '@/services/api/client';
import { kv } from '@/services/platform';
import type { Member } from '@/types/domain';

const CACHE_KEY = 'td.household.members';

interface State {
  members: Member[];
  loaded: boolean;
}

export const useMembersStore = defineStore('members', {
  state: (): State => ({ members: [], loaded: false }),
  getters: {
    byId(s): Record<string, Member> {
      return Object.fromEntries(s.members.map((m) => [m.id, m]));
    },
  },
  actions: {
    async load() {
      const cached = await kv.getJson<Member[]>(CACHE_KEY);
      if (cached) {
        this.members = cached;
        this.loaded = true;
      }
      try {
        const fresh = await householdApi.members();
        this.members = fresh;
        this.loaded = true;
        await kv.setJson(CACHE_KEY, fresh);
      } catch (e) {
        if (!(e instanceof NetworkError)) console.error('members.load', e);
      }
    },
    get(id: string): Member | undefined {
      return this.byId[id];
    },
  },
});
